<template>
  <div class="opinion">
    <div v-if="mode === 'notcomment'">
      <div class="box-notcomments">
        <div class="img-opinion-empty">
          <v-icon>search_off</v-icon>
        </div>
        <div class="text-opinion-empty">
          <span>کاربری نظر ثبت نکرده است</span>
        </div>
      </div>
    </div>
    <div v-else-if="mode === 'create'">
      <v-container>
        <div
          class="content-opinion"
          v-for="(item, index) in dataItem"
          :key="index"
        >
          <div class="title-content-opinion">
            <div class="title-content-opinion-r">
              <div class="img-title-content">
                <img src="../../assets/image/background_intro.png" alt="" />
              </div>
              <div class="text-title-opinion">
                <h6>{{ item.comment_presenter.name }}</h6>
                <span>1399-06-06</span>
              </div>
            </div>
            <div class="rate-user">
              <v-rating
                v-model="rating"
                background-color="#8f14c4"
                color="#8f14c4"
                large
              ></v-rating>
            </div>
          </div>
          <div class="text-content-opinion">
            <span v-html="item.comment_body" class="Comment_style"></span>
          </div>
          <div class="footer-content-opinion">
            <div class="img-footer-content">
              <img src="../../assets/image/welcome_emoji.jpg" alt="" />
            </div>
          </div>
          <div class="rate-footer-opinion">
            <span>{{ item.comment_like }}+</span>
            <v-icon>
              favorite_border
            </v-icon>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "opinion",
  data: () => ({
    rating: 5,
    mode: "create",
    dataItem: [],
    content_title: "",
  }),
  methods: {
    getDataComment(response) {
      this.dataItem = response.data;
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.content_title = this.$route.query.content_title;
    this.$root.$emit(
      "content_title",
      "تجربه کاربری" + "(" + this.content_title + ")"
    );
    oracle.axios(
      "comment/getList",
      {
        comment_type: 0,
        content_id: this.id,
        limit_by: 15,
        offset_by: 0,
      },
      this.getDataComment
    );
  },
};
</script>
<style>
.Comment_style {
  white-space: pre-line !important;
  word-wrap: break-word;
  /*padding-bottom: 30px;*/
}

.opinion {
  background-image: url("/img/background.15817e10.jpg");
  height: 100%;
  position: relative;
  background-size: cover;
  padding: 0;
  z-index: 10;
  overflow: auto;
  display: flex;
  justify-content: center;
}

.content-opinion {
  margin-top: 15px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
}

.content-opinion:first-child {
  margin-top: 8em;
}

.img-title-content {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
}

.img-title-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.text-title-opinion {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.text-title-opinion h6 {
  font-size: 13px;
}

.text-title-opinion span {
  font-size: 13px;
  color: #707070;
}

.title-content-opinion-r {
  display: flex;
  padding: 10px;
}

.rate-user .v-rating button {
  font-size: 15px !important;
  padding: 0;
}

.title-content-opinion {
  display: flex;
  justify-content: space-between;
}

.rate-user {
  padding: 20px;
}

.text-content-opinion span {
  font-size: 12px;
  line-height: 2;
}

.text-content-opinion {
  padding: 10px 15px;
}

.img-opinion-empty .v-icon {
  font-size: 70px;
  color: #0000cd;
  display: flex;
}

.text-opinion-empty {
  font-size: 15px;
  color: #0000cd;
}

.img-footer-content {
  text-align: center;
  width: 50%;
  height: 50%;
}

.img-footer-content img {
  width: 50%;
  height: 50%;
}

.footer-content-opinion {
  text-align: center;
  display: flex;
  justify-content: center;
}

.box-notcomments {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.rate-footer-opinion,
.rate-footer-opinion .v-icon {
  color: #50ac17;
  font-size: 20px;
  display: flex;
  justify-content: flex-end;
  padding: 5px 10px;
  align-items: center;
}

.rate-footer-opinion span {
  font-size: 15px;
}
</style>
